<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-app>
    <v-app-bar flat app>
      <v-img
        max-height="50"
        max-width="50"
        :src="logo"
        contain
        class="float-left mx-4"
      ></v-img>

      <v-toolbar-items class="ml-auto d-none d-md-block">
        <v-btn
          v-on:click="$vuetify.goTo('#start')"
          class="menu-button text-capitalize"
          text
          >Start</v-btn
        >
        <v-btn
          v-on:click="$vuetify.goTo('#haustier')"
          text
          class="menu-button text-capitalize"
          >Haustier</v-btn
        >
        <v-btn
          v-on:click="$vuetify.goTo('#nutztier')"
          text
          light
          class="menu-button text-capitalize"
          >Nutztier</v-btn
        >
        <v-btn
          v-on:click="$vuetify.goTo('#team')"
          text
          class="menu-button text-capitalize"
          >Team</v-btn
        >
        <v-btn
          v-on:click="$vuetify.goTo('#unterstuetzende')"
          text
          class="menu-button text-capitalize"
          >Unterstützende</v-btn
        >
        <v-btn
          v-on:click="$vuetify.goTo('#presse')"
          text
          class="menu-button text-capitalize"
          >Presse</v-btn
        >
        <v-btn
          v-on:click="$vuetify.goTo('#kontakt')"
          text
          class="menu-button text-capitalize"
          >Kontakt</v-btn
        >
      </v-toolbar-items>

      <v-menu offset-y class="ml-auto d-md-none">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" class="ml-auto d-md-none">
            <v-icon style="color:#54b0e4">more_vert</v-icon>
          </v-btn>
        </template>
        <v-flex style="background: white">
          <v-btn
            v-on:click="$vuetify.goTo('#start')"
            class="menu-button text-capitalize"
            text
            block
            >Start</v-btn
          >
          <v-btn
            v-on:click="$vuetify.goTo('#haustier')"
            text
            class="menu-button text-capitalize"
            block
            >Haustier</v-btn
          >
          <v-btn
            v-on:click="$vuetify.goTo('#nutztier')"
            text
            light
            class="menu-button text-capitalize"
            block
            >Nutztier</v-btn
          >
          <v-btn
            v-on:click="$vuetify.goTo('#team')"
            text
            class="menu-button text-capitalize"
            block
            >Team</v-btn
          >
          <v-btn
            v-on:click="$vuetify.goTo('#unterstuetzende')"
            text
            class="menu-button text-capitalize"
            block
            >Unterstützende</v-btn
          >
          <v-btn
            v-on:click="$vuetify.goTo('#presse')"
            text
            class="menu-button text-capitalize"
            block
            >Presse</v-btn
          >
          <v-btn
            v-on:click="$vuetify.goTo('#kontakt')"
            text
            class="menu-button text-capitalize"
            block
            >Kontakt</v-btn
          >
        </v-flex>
      </v-menu>
    </v-app-bar>

    <v-content>
      <router-view
        v-on:openPrivacyNotice="button_privacy_notice"
        v-on:openLegalNotice="button_legal_notice"
        class="pa-0"
      ></router-view>
    </v-content>

    <v-dialog v-model="dialog">
      <v-card>
        <v-card-text> <p v-html="legal_text"></p> </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn text v-on:click="noticeBtnClicked">{{ btn_text }}</v-btn>
          <v-spacer></v-spacer>

          <v-btn primary text @click="dialog = false">
            Schließen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="show_deactivate_snackbar"
      :timeout="0"
      :bottom="true"
      :right="true"
      :vertical="true"
    >
      {{ snackbar_text }}
      <v-layout>
        <v-btn dark small text v-on:click="abortClicked">
          {{ snackbar_btn_text }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn large dark text @click="okay_click">
          Okay
        </v-btn>
      </v-layout>
    </v-snackbar>
  </v-app>
</template>

<script>
import legal_notice from "../legal_texts/legal_notice";
import privacy_policy from "../legal_texts/privacy_policy";
export default {
  name: "App",
  data() {
    return {
      logo: require("./assets/images/logo.svg"),
      btn_text: "Analytics aktivieren",
      snackbar_text:
        "Vetvise nutzt Analytics, um Ihr Erlebnis zu verbessern. Weitere Informationen finden Sie in der Datenschutzerklärung.",
      show_deactivate_snackbar: true,
      legal_title: "",
      legal_text: "",
      dialog: false,
      tracking_enabled: false,
      snackbar_btn_text: "Abbrechen"
    };
  },
  created() {
    this.$ga.disable();
  },
  methods: {
    button_privacy_notice() {
      if (!this.dialog) {
        this.legal_text = privacy_policy;
        this.legal_title = "Datenschutzerklärung";
      }
      this.dialog = !this.dialog;
    },

    button_legal_notice() {
      if (!this.dialog) {
        this.legal_text = legal_notice;
        this.legal_title = "Impressum";
      }
      this.dialog = !this.dialog;
    },

    noticeBtnClicked() {
      if (this.tracking_enabled) this.disableTracking();
      else this.enableTracking();
    },
    abortClicked() {
      this.show_deactivate_snackbar = false;
    },

    okay_click() {
      this.enableTracking();
      this.btn_text = "Analytics deaktivieren";
      this.snackbar_btn_text = "Deaktivieren";
      this.show_deactivate_snackbar = false;
    },

    disableTracking() {
      this.$ga.disable();
      this.tracking_enabled = false;
      this.btn_text = "Analytics aktivieren";
      this.show_deactivate_snackbar = false;
    },

    enableTracking() {
      this.$ga.enable();
      this.btn_text = "Analytics deaktivieren";
      this.tracking_enabled = true;
    }
  }
};
</script>
<style>
#app {
  font-family: "Quicksand", sans-serif;
}
.menu-button {
  color: #54b0e4 !important;
  font-weight: bold;
  font-size: 17px !important;
}
</style>
